<!-- =========================================================================================
    File Name: Main.vue
    Description: Main layout
    ----------------------------------------------------------------------------------------
    Item Name: ITAT Time    

========================================================================================== -->


<template>
  <div class="layout--main" :class="[layoutTypeClass, navbarClasses, footerClasses, {'no-scroll': isAppPage}]">
    <GlobalLoadingBar />
    <div  v-if="doneLoading">
      <v-nav-menu
        :navMenuItems = "navMenuItems"
        title         = 'ITAT Time'
        parent        = ".layout--main" />

      <div id="content-area" :class="[contentAreaClass, {'show-overlay': bodyOverlay}]">
        <div id="content-overlay" />

      <!-- Navbar -->
      <template v-if="mainLayoutType === 'horizontal' && windowWidth >= 1200">
        <the-navbar-horizontal
          :navbarType= "navbarType"
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]" />

        <div style="height: 62px" v-if="navbarType === 'static'"></div>

        <h-nav-menu
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]"
          :navMenuItems="navMenuItems" />
      </template>

      

      <template v-else>
        <the-navbar-vertical
          :navbarColor="navbarColor"
          :class="[
            {'text-white' : isNavbarDark  && !isThemeDark},
            {'text-base'  : !isNavbarDark && isThemeDark}
          ]" />
      </template>

      <!-- <transition name="fade" mode="out-in"> -->
        <current-time-entry ></current-time-entry>
      <!-- </transition> -->
      <!-- /Navbar -->

        <div class="content-wrapper" v-if="userLoggedIn">

          

          <div class="router-view">
            <div class="router-content">

              <transition :name="routerTransition">

                <div v-if="$route.meta.breadcrumb || $route.meta.pageTitle" class="router-header flex flex-wrap items-center mb-6">
                  <div
                    class="content-area__heading"
                    :class="{'pr-4 border-0 md:border-r border-solid border-grey-light' : $route.meta.breadcrumb}">
                    <h2 class="mb-1">{{ routeTitle }}</h2>
                  </div>

                  <!-- BREADCRUMB -->
                  <vx-breadcrumb class="ml-4 md:block hidden" v-if="$route.meta.breadcrumb" :route="$route" :isRTL="$vs.rtl" />

                  <!-- DROPDOWN -->
                  <vs-dropdown vs-trigger-click class="ml-auto md:block hidden cursor-pointer">
                    <vs-button radius icon="icon-settings" icon-pack="feather" />

                    <vs-dropdown-menu class="w-32">
                      <vs-dropdown-item>
                        <div @click="$router.push('/pages/profile').catch(() => {})" class="flex items-center">
                          <feather-icon icon="UserIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                          <span>Profile</span>
                        </div>
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <div @click="$router.push('/apps/todo').catch(() => {})" class="flex items-center">
                          <feather-icon icon="CheckSquareIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                          <span>Tasks</span>
                        </div>
                      </vs-dropdown-item>
                      <vs-dropdown-item>
                        <div @click="$router.push('/apps/tasks').catch(() => {})" class="flex items-center">
                          <feather-icon icon="MailIcon" class="inline-block mr-2" svgClasses="w-4 h-4" />
                          <span>Inbox</span>
                        </div>
                      </vs-dropdown-item>
                    </vs-dropdown-menu>

                  </vs-dropdown>

                </div>
              </transition>

              <div class="content-area__content">

                <back-to-top bottom="5%" :right="$vs.rtl ? 'calc(100% - 2.2rem - 38px)' : '30px'" visibleoffset="500" v-if="!hideScrollToTop">
                  <vs-button icon-pack="feather" icon="icon-arrow-up" class="shadow-lg btn-back-to-top" />
                </back-to-top>

                <transition :name="routerTransition" mode="out-in">
                  <router-view @changeRouteTitle="changeRouteTitle" @setAppClasses="(classesStr) => $emit('setAppClasses', classesStr)" />
                </transition>
              </div>
            </div>
          </div>
        </div>
        <the-footer />
      </div>
    </div>

    		<!-- TIME ENTRY MODAL -->
		<vs-prompt 
			color="primary"
      class="time-entry-prompt"
			:title="tempTimeEntryPrompt.title"
      prevent-close
			@cancel="CancelTimeEntryPrompt"
			@accept="AcceptTimeEntryPrompt"
			@close="CancelTimeEntryPrompt"
      :buttons-hidden="true"
			:is-valid="timeEntryPromptValid && ((overageApproved && overage > 0) || overage <= 0)"
			:active="timeEntryPrompt.active">

      <!-- <vs-alert color="primary" style="height: 60px;" v-if="tempTimeEntryPrompt.Posted">
        Time entry is posted
      </vs-alert> -->



			<div class="con-exemple-prompt time-entry-modal-layout">
        <div class="time-entry-modal-body">
          <transition name="fade" mode="out-in">
            <div :key="selectingTemplate ? 1 : 0">
              <div>
                <div v-if="selectingTemplate == 0">

                <h5 class="mb-2">{{entryDate}}</h5>
                <v-select @input="OnChangedClient" :options="clientList" :reduce="x => x.ClientID" label="ClientName" v-model="tempTimeEntryPrompt.clientID" placeholder="Client" :title="timeEntryClientTitle" class="time-entry-ellipsis-select" />
                

                <!-- Category -->
                <div>
                  <div class="sow-notification" v-if="noSOWDefined && tempTimeEntryPrompt.jiraIssueID != null"><div class="square"></div><div class="text">No S.O.W. defined for this task</div></div>
                  <div class="flex items-end" v-if="!creatingCategory">
                    <v-select @input="OnChangedCategory" :options="categoryList" :reduce="x=>x.CategoryID" label="CategoryName" v-model="tempTimeEntryPrompt.categoryID" placeholder="Category" class="mt-2 flex-grow time-entry-ellipsis-select" :title="timeEntryCategoryTitle" :class="{ dropdownDisabled: categoryDropdownDisabled }"/>
                    <vs-button v-if="tempTimeEntryPrompt.clientID && isAdmin" @click="BeginCreateCategory" icon-pack="feather" icon="icon-plus" class="ml-2"></vs-button>
                  </div>
                  <form class="flex items-end" v-else @submit.stop.prevent="CreateCategory" @keydown.esc.prevent="CancelCreateCategory">
                    <vs-input ref="newCategoryInput" v-model="newCategory" class="flex-grow mr-2 mt-2" @keydown.enter.native.prevent="CreateCategory"></vs-input>
                    <vs-button @click="CancelCreateCategory" icon-pack="feather" icon="icon-x" class="mr-1"></vs-button>
                    <vs-button @click="CreateCategory" :disabled="savingCategory" icon-pack="feather" icon="icon-arrow-right" type="submit"></vs-button>
                  </form>
                </div>

                <!-- SOW -->
                <div>
                  <div class="flex items-end">
                    <v-select @input="onChangedSOW" :options="mySOWs" :reduce="x => x.SOWID" label="SOWName" v-model="tempTimeEntryPrompt.sowID" placeholder="SOW" class="mt-2 flex-grow time-entry-ellipsis-select" :title="timeEntrySOWTitle" />
                    <vs-button v-if="isAdmin" @click="BeginCreateSOW" icon-pack="feather" icon="icon-plus" class="ml-2"></vs-button>
                  </div>
                  <div v-if="tempTimeEntryPrompt.sowID">
                    <div class="flex items-end time-entry-task-row" v-if="!creatingTask">
                      <v-select @input="onChangedSOWLineItem" :options="mySOWLineItemsFiltered" :reduce="x => x.SOWLineItemID" label="Title" v-model="tempTimeEntryPrompt.sowLineItemID" placeholder="Task" class="mt-2 flex-grow time-entry-task-select time-entry-ellipsis-select" :title="timeEntryTaskTitle" />
                      <vs-button v-if="isAdmin" @click="BeginCreateTask" icon-pack="feather" icon="icon-plus" class="ml-2"></vs-button>
                    </div>
                    <form class="flex items-end" v-else @submit.stop.prevent="CreateTask" @keydown.esc.prevent="CancelCreateTask">
                      <vs-input ref="newTaskInput" v-model="newTaskDescription" class="flex-grow mr-2 mt-2" placeholder="Task description" @keydown.enter.native.prevent="CreateTask"></vs-input>
                      <vs-button @click="CancelCreateTask" icon-pack="feather" icon="icon-x" class="mr-1"></vs-button>
                      <vs-button @click="CreateTask" :disabled="savingTask" icon-pack="feather" icon="icon-arrow-right" type="submit"></vs-button>
                    </form>
                  </div>
                  <v-select v-else @input="onChangedSOWLineItem" :options="mySOWLineItemsFiltered" :reduce="x => x.SOWLineItemID" label="Title" v-model="tempTimeEntryPrompt.sowLineItemID" placeholder="Task" class="mt-2 time-entry-task-select time-entry-ellipsis-select" :title="timeEntryTaskTitle" />
                </div>
                
                
              <div v-if="tempTimeEntryPrompt.task && tempTimeEntryPrompt.task.fields && overage > 0" class="my-2">
                  <vs-alert color="danger" style="height: 60px;">
                    {{ (tempTimeEntryPrompt.task.fields.timespent - tempTimeEntryPrompt.task.fields.timeoriginalestimate).toFixed(2) }} hrs over {{ tempTimeEntryPrompt.task.fields.timeoriginalestimate.toFixed(2) }} estimate
                    <br/>
                    Is the overage approved?
                    <vs-checkbox v-model="overageApproved" class="float-right" color="danger" style="margin-top: -10px;"></vs-checkbox>
                  </vs-alert>
                </div>
            <div v-if="(tempTimeEntryPrompt.jiraIssueID != null || tempTimeEntryPrompt.taskID != null) && tempTimeEntryPrompt.task != null && tempTimeEntryPrompt.task.fields" class="mt-2">
                  <vs-alert color="primary">Task Status: <br/><span style="color:white;"><b>{{tempTimeEntryPrompt.task.fields.status.name}}</b></span>
                    <vs-button size="small" class="taskStatusButton" color="primary" @click="SelectStatusChanger()">Change Status</vs-button>
                    <vs-button size="small" class="taskStatusButton second" color="primary" @click="ViewTaskInJira()">View in Jira</vs-button>
                  </vs-alert>
                </div>


                <vs-textarea rows="5" v-model="tempTimeEntryPrompt.description" label="Description" class="mt-2 timeEntryTextArea"></vs-textarea>
                
                <!-- START TIME -->
                <div class="flex flex-inline timeEntryDateFields mb-2">
                  <div class="timeEntryTimeLabel">
                    <a href="#" @click="UpdateStartTime">Start Time:</a>
                  </div>
                  <div class="timeEntryFieldsRow">
                    <flat-pickr ref="fpStartTime" style="min-width: 0px;" :config="timePickerConfig" v-model="timeEntryStartTime" placeholder="Start Time" />
                    <div class="timeEntryDateSlot relative">
                      <flat-pickr ref="fpStartDate" style="min-width: 0px;" :config="datePickerConfig" v-model="timeEntryStartDate" placeholder="Start Date" @on-change="onFromChange" />
                      <vs-button v-if="mostRecentCompletedEntry != null" color="primary" class="timeEntryUseLastEndBtn" radius size="small" icon="history" @click="UseMostRecentEndForStartTime()"></vs-button>
                    </div>
                  </div>
                </div>


                <!-- END TIME -->
                <div class="flex flex-inline timeEntryDateFields items-center" v-if="timeEntryEndTime != null">
                  <div class="timeEntryTimeLabel">
                    <a href="#" @click="UpdateEndTime">End Time:</a>
                  </div>
                  <div class="timeEntryFieldsRow">
                    <flat-pickr ref="fpEndTime" style="min-width: 0px;" :config="timePickerConfig" v-model="timeEntryEndTime" :placeholder="tempTimeEntryPrompt.action!='clockin'?'End Time':'-'" :disabled="tempTimeEntryPrompt.action=='clockin'"/>
                    <div class="timeEntryDateSlot relative">
                      <flat-pickr ref="fpEndDate" style="min-width: 0px;" :config="datePickerConfig" v-model="timeEntryEndDate" @on-change="onToChange" :placeholder="tempTimeEntryPrompt.action!='clockin'?'End Date':'-'" :disabled="tempTimeEntryPrompt.action=='clockin'"/>
                      <vs-button v-if="tempTimeEntryPrompt.action =='create' || tempTimeEntryPrompt.action == 'clockin'" color="danger" class="timeEntryRemoveEndBtn" radius size="small" icon="remove" @click="RemoveEndTime()"></vs-button>
                    </div>
                  </div>
                </div>            
                <div v-else>
                  <vs-button v-if="tempTimeEntryPrompt.action != 'clockin'" class="float-right" icon="add" @click="AddEndTime()" style="width:78%;">Add End Time</vs-button>
                  <br/><br/>
                </div>

                <vs-input type="number" v-model="tempTimeEntryPrompt.mileage" label="Mileage" class="mt-2"></vs-input>


                <vs-alert :active="!timeEntryPromptValid" color="danger" icon="new_releases" class="mt-6">
                {{tempTimeEntryPrompt.error}}
                </vs-alert>

                <vs-alert icon="new_releases" color="danger" v-if="TimeOverlapping" class="mt-1">OVERLAPPING WITH TIME ENTRIES</vs-alert>


              </div>
              <div v-if="selectingTemplate == 1">
                <vs-button color="primary" type="relief" class="mb-5" size="small" @click="CancelSelectTemplate()">Cancel</vs-button>
              
                <component ref="scroll" :is="scrollbarTag" class="email-content-scroll-area" :settings="settings" :key="$vs.rtl" style="height: 480px;">
                    <transition-group name="list-enter-up" class="email__mails" tag="ul" appear>
                        
                        <vs-card class="cardx" v-for="(entry, index) in timeEntryList" :key="'entry'+entry.RecordID" :style="{transitionDelay: (index * 0.06) + 's'}" style="background-color: rgb(60 68 103);" >
                            <div slot="header" class="flex" style="margin: -4px;">
                              <vs-chip color="primary" class="my-1 mr-1"><span style="color:white">{{GetTimeDif(entry.TimeIn, entry.TimeOut)}}</span> </vs-chip>
                              <vs-chip color="primary" class="my-1 mr-1"> <span style="color:white">{{GetDateDay(entry.TimeIn)}}</span></vs-chip>
                              <h5 class="mt-2" style="position: absolute; right: 15px;">
                                {{GetClientByID(entry.ClientID).ClientName}}
                              </h5>
                            </div>
                            <div>
                              <span style="color: #9099bd; font-weight: bold;">{{GetDateTimes(entry.TimeIn, entry.TimeOut)}}</span>
                              <h6 class="mt-1">Category: {{GetCategoryByID(entry.CategoryID).CategoryName}}</h6>
                              
                              <div class="mt-2">{{entry.Note}}</div>
                            </div>
                            <div slot="footer">
                              <vs-row vs-justify="flex-end">
                                <vs-button color="primary" type="gradient" @click="SelectTemplate(entry)">Use</vs-button>
                              </vs-row>
                            </div>
                          </vs-card>
                                      
                        <!-- <li class="email__mail-item" v-for="(entry, index) in timeEntryList" :key="'entry'+entry.RecordID" :style="{transitionDelay: (index * 0.1) + 's'}"> 
                            <time-entry-template :clientName="GetClientByID(entry.ClientID).ClientName" />
                        </li> -->
                    </transition-group>
                </component>
                
              </div>
              <div v-if="selectingTemplate == 2">
                <vs-button color="primary" type="relief" class="mb-5" size="small" @click="selectingTemplate = 0">Cancel</vs-button>

                <!-- {{projectStatuses}} -->
                <!-- {{projectStatuses[tempTimeEntryPrompt.projectID].length}} -->

                <!-- <vx-timeline :data="timelineData"></vx-ine> -->

              <!-- <ul class="vx-timeline">
                <li v-for="(item, index) in projectStatuses[tempTimeEntryPrompt.projectID]" :key="index">
                  <div class="timeline-icon" :style="TimelineStyle(index, projectStatuses[tempTimeEntryPrompt.projectID].length)">
                    <feather-icon  v-if="tempTimeEntryPrompt.task.fields.status.name == item.name" icon="CheckIcon" svgClasses="text-white stroke-current w-5 h-5" />
                    <feather-icon  v-else icon="ListIcon" svgClasses="text-white stroke-current w-5 h-5" />

                  </div>
                  <div class="timeline-info">
                    <div v-if="tempTimeEntryPrompt.task.fields.status.name == item.name">
                      <vs-button class="statusButton"><span style="color:white;">{{item.name}}</span></vs-button>
                    </div>
                    <div v-else>
                      <vs-button type="border" class="statusButton" @click="ChangeStatus(item)"><span style="color:white;">{{item.name}}</span></vs-button>
                    </div>
                  </div>
                </li>
              </ul> -->


                </div>
              </div>
            </div>
          </transition>
        </div>
        <div class="time-entry-modal-footer">
          <div v-if="confirmingCompleteLineItem" class="time-entry-prompt-footer-row">
            <div class="mr-auto">
              Mark task as completed?
            </div>
            <vs-button color="secondary" @click="confirmingCompleteLineItem = false" class="mr-2">Cancel</vs-button>
            <vs-button :disabled="completingLineItem || savingTimeEntry" @click="FinishMarkTaskComplete">{{ completingLineItem ? 'Completing...' : 'Complete Task & Save' }}</vs-button>
          </div>
          <div v-else class="time-entry-prompt-footer-row">
            <div class="time-entry-prompt-footer-left">
              <vs-button
                v-if="selectingTemplate == 0 && deletingEntry"
                type="border"
                color="primary"
                icon-pack="feather"
                icon="icon-x"
                @click="deletingEntry = false"
                class="mr-2">
              </vs-button>
              <vs-button
                v-if="selectingTemplate == 0 && tempTimeEntryPrompt.action == 'edit' && !tempTimeEntryPrompt.Posted"
                color="danger"
                icon-pack="feather"
                :icon="deletingEntry ? 'icon-check' : 'icon-trash'"
                @click="deletingEntry ? ConfirmDeleteEntry() : (deletingEntry = true)">
              </vs-button>
            </div>
            <div class="time-entry-prompt-footer-right">
              <vs-button
                v-if="selectingTemplate == 0 && selectedSOWLineItem"
                @click="BeginMarkComplete()"
                v-show="selectedSOWLineItem.CompletedOn == null"
                color="primary"
                class="ml-2">
                Complete Task & Save
              </vs-button>
              <vs-button
                v-if="selectingTemplate == 0 && selectedSOWLineItem"
                v-show="selectedSOWLineItem.CompletedOn != null"
                color="success"
                disabled="true"
                class="ml-2"
              >Task Completed</vs-button>
              <vs-button @click="AcceptTimeEntryPrompt" :disabled="savingTimeEntry || !(timeEntryPromptValid && ((overageApproved && overage > 0) || overage <= 0))" color="primary">{{ savingTimeEntry ? 'Saving...' : 'Save' }}</vs-button>
              <vs-button @click="CancelTimeEntryPrompt" type="flat" color="secondary" class="ml-2">Cancel</vs-button>
            </div>
          </div>
        </div>
			</div>
     </vs-prompt>
	 <!-- END TIME ENTRY MODAL -->

    <SOWModal ref="sowModal" :base-layer="1" :default-client-id="tempTimeEntryPrompt.clientID" @saved="OnSOWCreatedFromTimeEntry" />


  </div>
</template>


<script>
import BackToTop           from 'vue-backtotop'
import HNavMenu            from '@/layouts/components/horizontal-nav-menu/HorizontalNavMenu.vue'
import navMenuItems        from '@/layouts/components/vertical-nav-menu/navMenuItems.js'
import TheNavbarHorizontal from '@/layouts/components/navbar/TheNavbarHorizontal.vue'
import TheNavbarVertical   from '@/layouts/components/navbar/TheNavbarVertical.vue'
import TheFooter           from '@/layouts/components/TheFooter.vue'
import themeConfig         from '@/../themeConfig.js'
import VNavMenu            from '@/layouts/components/vertical-nav-menu/VerticalNavMenu.vue'
import './TimeStyling.css'
import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import vSelect from 'vue-select'
var moment = require('moment'); // require
import CurrentTimeEntry     from '../components/CurrentTimeEntry.vue'
import VuePerfectScrollbar  from 'vue-perfect-scrollbar'
import TimeEntryTemplate from './TimeEntryTemplate.vue'
import VxTimeline          from '@/components/timeline/VxTimeline.vue'
import SOWModal            from '@/components/SOWModal.vue'
import GlobalLoadingBar    from '@/components/GlobalLoadingBar.vue'

export default {
  components: {
    BackToTop,
    HNavMenu,
    TheFooter,
    TheNavbarHorizontal,
    TheNavbarVertical,
    VNavMenu,
    flatPickr,
    'v-select': vSelect,
    CurrentTimeEntry,
    TimeEntryTemplate,
    VuePerfectScrollbar,
    VxTimeline,
    SOWModal,
    GlobalLoadingBar
  },
  data() {
    return {
      overageApproved: false,
      pendingTask: null,
      settings             : {
        maxScrollbarLength : 60,
        wheelSpeed         : 0.30
      },
      selectingTemplate: 0,
      timeEntryStartTime: null,
      timeEntryStartDate: null,
      timeEntryEndTime: null,
      timeEntryEndDate: null,
      doneLoading       : false,
      deletingEntry     : false,
      orphanSOWLineItems: [],
      footerType        : themeConfig.footerType  || 'static',
      hideScrollToTop   : themeConfig.hideScrollToTop,
      isNavbarDark      : false,
      navbarColor       : themeConfig.navbarColor || '#fff',
      navbarType        : themeConfig.navbarType  || 'floating',
      navMenuItems,
      routerTransition  : themeConfig.routerTransition || 'none',
      routeTitle        : this.$route.meta.pageTitle,
      configdateTimePicker: {
				enableTime: true,
				dateFormat: 'd-m-Y H:i K'
      },
      tempTimeEntryPrompt : {
        active: false,
        title: "Create New Time Entry",
        taskName: "",
        clientName: "Client Name",
        clientCategory: "Client Category",
        projectID: null,
        startTime: new Date(),
        endTime: new Date(),
        startDate: new Date(),
        endDate: new Date(),
        jiraIssueID: "",
        description: "",
        error: "Fields cannot be empty.",
        recordID:0,
        mileage: 0,
        sowID: null,
        sowLineItemID: null,
      },
      timePickerConfig: {
          enableTime: true,
          enableSeconds: false,
          // allowInput: true,
          noCalendar: true,
          time_24hr: false,
          dateFormat: "G:i K"
          
        },
        time: null,
      datePickerConfig: {
        minDate: null
      },
      fromDate: null,
      toDate: null,
      timelineData: [
        {
          color : 'primary',
          icon  : 'PlusIcon',
          title : 'New Task Added',
          desc  : 'Bonbon macaroon jelly beans gummi bears jelly lollipop apple',
          time  : '25 Days Ago'
        },
        {
          color : 'warning',
          icon  : 'AlertCircleIcon',
          title : 'Task Update Found',
          desc  : 'Cupcake gummi bears soufflé caramels candy',
          time  : '15 Days Ago'
        },
        {
          color : 'success',
          icon  : 'CheckIcon',
          title : 'Task Finished',
          desc  : 'Candy ice cream cake. Halvah gummi bears',
          time  : '20 mins ago'
        }
      ],
      noSOWDefined: false,
      confirmingCompleteLineItem: false,
      creatingCategory: false,
      newCategory: '',
      savingCategory: false,
      creatingTask: false,
      newTaskDescription: '',
      savingTask: false,
      savingTimeEntry: false,
      completingLineItem: false,
    }
  },
  watch: {
    simulation(){
      this.OnLoggedIn(true)
    },
    userLoggedIn : function(loggedIn){
			if(loggedIn)
			{
        this.OnLoggedIn()
			}
		},
    loadingAuth(val) {
      if (val == false && this.$auth.isAuthenticated == false) {
        this.$router.replace('/')
      }
    },
    timeEntryPromptActive(isActive) {
      if (isActive) {
        this.$nextTick(() => {
          document.addEventListener('scroll', this.repositionTimeEntryFlatpickrs, true)
        })
      } else {
        document.removeEventListener('scroll', this.repositionTimeEntryFlatpickrs, true)
      }
    },
    // If users click on a time entry before tasks are fully loaded
    taskList() {
      this.tempTimeEntryPrompt.jiraIssueID = this.timeEntryPrompt.jiraIssueID
      var jiraIssueID = this.tempTimeEntryPrompt.jiraIssueID
      if(jiraIssueID != null){
         var jiraIssue = this.GetTaskByID(jiraIssueID)
         if (jiraIssue != null) {
          this.tempTimeEntryPrompt.jiraIssueID = jiraIssue.id
          this.tempTimeEntryPrompt.jiraIssue = jiraIssue

          const client = null
          if (client != null) {
            this.tempTimeEntryPrompt.clientID = client.ClientID
          }
         }else{
           this.tempTimeEntryPrompt.jiraIssueID = null
         }
      }
    },
    timeEntryPromptTick(val){
      this.pendingTask = null
      this.noSOWDefined = false
      this.deletingEntry = false
      const nextPrompt = this.timeEntryPrompt
      const nextSowLineItemID = nextPrompt.sowLineItemID
      const hadOrphanForSameItem = this.orphanSOWLineItems.length > 0 && this.orphanSOWLineItems[0].SOWLineItemID === nextSowLineItemID
      if (!nextSowLineItemID || !hadOrphanForSameItem) {
        this.orphanSOWLineItems = []
      }
      this.tempTimeEntryPrompt = JSON.parse(JSON.stringify(this.timeEntryPrompt))
      this.timeEntryStartTime = this.tempTimeEntryPrompt.startTime
      this.timeEntryEndTime = this.tempTimeEntryPrompt.endTime
      this.timeEntryStartDate = this.tempTimeEntryPrompt.startDate
      this.timeEntryEndDate = this.tempTimeEntryPrompt.endDate
      
      this.overageApproved = false

      var jiraIssueID = this.tempTimeEntryPrompt.jiraIssueID
      var jiraIssueKey = this.tempTimeEntryPrompt.jiraIssueKey

      setTimeout(() => {

        Array.from(document.getElementsByClassName("vs-dialog-dark")).forEach(
            function(x, index, array) {
              x.style.pointerEvents = 'none'
            }
        );

      }, 100)

      if(jiraIssueID != null){
        var jiraIssue = this.GetTaskByID(jiraIssueID)
        if(jiraIssue != null){
          this.tempTimeEntryPrompt.jiraIssueID = jiraIssue.id
          this.tempTimeEntryPrompt.jiraIssueKey = jiraIssue.key
          this.tempTimeEntryPrompt.task = jiraIssue

          const client = null
          if (client != null) {
            this.tempTimeEntryPrompt.clientID = client.ClientID
          }
        } else {
           this.pendingTask = jiraIssueID
           this.tempTimeEntryPrompt.jiraIssueID = null
         }
      }
      if (this.tempTimeEntryPrompt.taskID != null || this.tempTimeEntryPrompt.sowLineItemID != null) {
        const v2Task = this.taskList.find(x => x.TaskID === this.tempTimeEntryPrompt.taskID || x.SOWLineItemID === this.tempTimeEntryPrompt.sowLineItemID)
        if (v2Task) this.tempTimeEntryPrompt.task = v2Task
      }
      const needOrphanFetch = (this.tempTimeEntryPrompt.action === 'edit' || this.tempTimeEntryPrompt.action === 'clockout') &&
        this.tempTimeEntryPrompt.sowLineItemID != null &&
        this.tempTimeEntryPrompt.sowID != null
      if (needOrphanFetch) {
        const inList = this.$store.getters.GetMySOWLineItems.some(x => x.SOWLineItemID === this.tempTimeEntryPrompt.sowLineItemID)
        const alreadyHaveOrphan = this.orphanSOWLineItems.some(x => x.SOWLineItemID === this.tempTimeEntryPrompt.sowLineItemID)
        if (!inList && !alreadyHaveOrphan) {
          this.$store.dispatch('ActionFetchSOWLineItems', this.tempTimeEntryPrompt.sowID).then(lineItems => {
            const item = lineItems.find(li => li.SOWLineItemID === this.tempTimeEntryPrompt.sowLineItemID)
            if (item) {
              const sowList = this.$store.getters.GetSOWList
              const sow = sowList && sowList.find(s => s.SOWID === this.tempTimeEntryPrompt.sowID)
              const enriched = {
                ...item,
                SOWName: sow ? sow.SOWName : '',
                CategoryID: sow ? sow.CategoryID : null,
                ClientID: sow ? sow.ClientID : null
              }
              this.orphanSOWLineItems = [enriched]
            }
          }).catch(() => {})
        }
      }
    },
    '$route' () {
      this.routeTitle = this.$route.meta.pageTitle
    },
    isThemeDark (val) {
      const color = this.navbarColor === '#fff' && val ? '#10163a' : '#fff'
      this.updateNavbarColor(color)
    },
    '$store.state.mainLayoutType' (val) {
      this.setNavMenuVisibility(val)
    }
  },
  beforeDestroy() {
    document.removeEventListener('scroll', this.repositionTimeEntryFlatpickrs, true)
  },
  computed: {
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
    mySOWLineItemsWithOrphans() {
      const list = this.$store.getters.GetMySOWLineItems
      return this.orphanSOWLineItems.length ? [...list, ...this.orphanSOWLineItems] : list
    },
    selectedSOWLineItem() {
      return this.mySOWLineItemsWithOrphans.find(x => x.SOWLineItemID == this.tempTimeEntryPrompt.sowLineItemID)
    },
    overage() {
      if (this.tempTimeEntryPrompt.task == null || !this.tempTimeEntryPrompt.task.fields) {
        return -1
      }
      if (this.tempTimeEntryPrompt.task.fields.timespent == null || this.tempTimeEntryPrompt.task.fields.timeoriginalestimate == null) {
        return -1
      }
      return this.tempTimeEntryPrompt.task.fields.timespent - this.tempTimeEntryPrompt.task.fields.timeoriginalestimate
    },
    isOver() {
      return this.tempTimeEntryPrompt.task && this.tempTimeEntryPrompt.task.fields && this.tempTimeEntryPrompt.task.fields.timespent != null && this.tempTimeEntryPrompt.task.fields.timeoriginalestimate != null
    },
    selectedCatID() {
      return this.tempTimeEntryPrompt.categoryID
    },
    TimeOverlapping(){
      var timeIn = this.timeEntryStartDate + " " + this.GetFormattedTime(this.timeEntryStartTime)
      var timeOut = this.timeEntryEndTime == null ? null :  (this.timeEntryEndDate + " " + this.GetFormattedTime(this.timeEntryEndTime))
      var sampleIn = moment(new Date(timeIn))
      var sampleOut = moment(new Date(timeOut))

      for(var i = 0; i < this.timeEntryList.length; i++){
        var xIn = moment(new Date(this.timeEntryList[i].TimeIn))
        var xOut = moment(new Date(this.timeEntryList[i].TimeOut))
        if(sampleIn.isBetween(xIn, xOut) || sampleOut.isBetween(xIn,xOut)){
          return true
        }

      }
      return false
    },
    projectStatuses(){
      return this.$store.getters.GetProjectStatuses
    },
    entryDate(){
      return moment().format("M/D/YY - h:mm A")
    },
    simulation () {
      return this.$store.getters.GetSimulation
    },
    workerID(){
			return this.$store.getters.GetWorkerID
		},
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    timeEntryList(){
      var list = this.$store.getters.GetTimeEntryList
			return list.filter(x => x.WorkerID == this.workerID)
			
     //return list
		},
    mostRecentCompletedEntry () {
      const list = this.$store.getters.GetTimeEntryList || []
      let latest = null
      let latestMs = -1
      for (let i = 0; i < list.length; i++) {
        const entry = list[i]
        if (entry == null || entry.TimeOut == null) continue
        if (entry.WorkerID != null && this.workerID != null && entry.WorkerID != this.workerID) continue
        const ms = moment(entry.TimeOut).valueOf()
        if (isNaN(ms)) continue
        if (ms > latestMs) {
          latest = entry
          latestMs = ms
        }
      }
      return latest
    },
    mySOWLineItems() {
      return this.$store.getters.GetMySOWLineItems
    },
    mySOWLineItemsFiltered() {
      let list = this.mySOWLineItemsWithOrphans
      if (this.tempTimeEntryPrompt.clientID != null) {
        list = list.filter(x => x.ClientID == this.tempTimeEntryPrompt.clientID)
      }
      if (this.tempTimeEntryPrompt.categoryID != null) {
        list = list.filter(x => x.CategoryID == this.tempTimeEntryPrompt.categoryID)
      }
      if (this.tempTimeEntryPrompt.sowID == null) {
        return list.map(x => {
          return {
            ...x,
            Title: `${x.SOWName || ''} - ${x.Title}`
          }
        })
      } else {
        return list.filter(x => x.SOWID == this.tempTimeEntryPrompt.sowID)
      }
    },
    timeEntryClientTitle () {
      if (this.tempTimeEntryPrompt.clientID == null) return ''
      const client = this.clientList.find(x => x.ClientID == this.tempTimeEntryPrompt.clientID)
      return client && client.ClientName ? client.ClientName : ''
    },
    timeEntryCategoryTitle () {
      if (this.tempTimeEntryPrompt.categoryID == null) return ''
      const category = this.$store.getters.GetCategoryList.find(x => x.CategoryID == this.tempTimeEntryPrompt.categoryID)
      return category && category.CategoryName ? category.CategoryName : ''
    },
    timeEntrySOWTitle () {
      if (this.tempTimeEntryPrompt.sowID == null) return ''
      const sow = this.mySOWs.find(x => x.SOWID == this.tempTimeEntryPrompt.sowID)
      return sow && sow.SOWName ? sow.SOWName : ''
    },
    timeEntryTaskTitle () {
      if (this.tempTimeEntryPrompt.sowLineItemID == null) return ''
      const item = this.mySOWLineItemsFiltered.find(x => x.SOWLineItemID == this.tempTimeEntryPrompt.sowLineItemID)
      return item && item.Title ? item.Title : ''
    },
    mySOWs() {
      let ret = []
      this.mySOWLineItemsWithOrphans.forEach(x => {
        if (ret.find(y => y.SOWID == x.SOWID) == null) {
          ret.push({
            SOWName: x.SOWName,
            SOWID: x.SOWID,
            CategoryID: x.CategoryID,
            ClientID: x.ClientID,
          })
        }
      })
      if (this.tempTimeEntryPrompt.categoryID != null) {
        ret = ret.filter(x => x.CategoryID == this.tempTimeEntryPrompt.categoryID)
      }

      if (this.tempTimeEntryPrompt.clientID != null) {
        ret = ret.filter(x => x.ClientID == this.tempTimeEntryPrompt.clientID)
      }

      return ret
    },
    categoryDropdownDisabled(){
      if(this.tempTimeEntryPrompt.action == "edit")
        return false

      if(this.tempTimeEntryPrompt.clientID != null && this.tempTimeEntryPrompt.jiraIssueID == null)
        return false

      return true
    },
    projectDropdownDisabled(){
      if(this.tempTimeEntryPrompt.action == "edit")
        return false

      if(this.tempTimeEntryPrompt.clientID != null && this.tempTimeEntryPrompt.jiraIssueID == null)
      return false

      return true
    },
    userLoggedIn(){
			return this.$auth.isAuthenticated
		},
    loadingAuth() {
      return this.$auth.loading
    },
    isAdmin () {
      return this.$store.getters.GetIsAdmin
    },
		clientList (){
			return this.$store.getters.GetClientList
    },
    rawCategoryList() {
	    return this.$store.getters.GetCategoryList
    },
    // concatCategoryList() {
    //   const a = this.$store.getters.GetCategoryList.filter(x => x.ClientID == this.tempTimeEntryPrompt.clientID)
    //   const b = this.$store.getters.GetCategoryListSOW
    //   const c = a.concat(b)
    //   console.log('b', b)
    //   return c
    // },
		categoryList() {
      if (this.tempTimeEntryPrompt.action == 'edit') {
        
        return this.$store.getters.GetCategoryList.filter(x => x.ClientID == this.tempTimeEntryPrompt.clientID)
      }
      if (this.tempTimeEntryPrompt.task == null) {
			  return this.$store.getters.GetCategoryList.filter(x => x.ClientID == this.tempTimeEntryPrompt.clientID)
      }
      const task = this.tempTimeEntryPrompt.task
      const categoryId = task.fields ? task.ITATCategoryID : task.CategoryID
      if (categoryId != null) {
        const category = this.rawCategoryList.find(x => x.CategoryID == categoryId)
        if (category != null) {
          return [category]
        } else {
          return []
        }
      } else {
        this.noSOWDefined = true
        return []
      }
      
    },
    taskList(){
      return this.$store.getters.GetMyTaskListV2
    },
    potentialExternalTask() {
      return this.$store.getters.GetPotentialExternalTask
    },
    // illegalSOW() {
    //   const cat = this.GetCategoryByID(this.tempTimeEntryPrompt.categoryID)
    //   let catName = ''
    //   if (cat != null) {
    //     catName = cat.CategoryName
    //   } else {
    //     return false
    //   }
    //   if (catName == 'Undefined') {
    //     return false
    //   }
    //   if (this.taskList.find(x => x.JiraInfo.SOW === catName) == null) {
    //     return true
    //   }
    //   return false
    // },
    filteredTaskList(){
      if (this.tempTimeEntryPrompt.clientID == -1 || isNaN(this.tempTimeEntryPrompt.clientID) || this.tempTimeEntryPrompt.clientID == null) {
        return this.taskList
      }
      let ret = this.taskList.filter(x => x.ClientID == this.tempTimeEntryPrompt.clientID)
      if (this.tempTimeEntryPrompt.categoryID != null) {
        ret = ret.filter(x => x.CategoryID == this.tempTimeEntryPrompt.categoryID)
      }
      ret = ret.filter(x => x.CompleteDate == null)
      return ret
    },
    projectList(){
      return this.$store.getters.GetProjectList
    },
    filteredProjectList(){
      if(this.tempTimeEntryPrompt.clientID == -1 || isNaN(this.tempTimeEntryPrompt.clientID))
        return this.projectList;

      return this.projectList.filter(x => x.ITATInfo.ClientID == this.tempTimeEntryPrompt.clientID)
    },
    timeEntryPromptValid(){

      if (this.tempTimeEntryPrompt.action == 'edit') {
        if (this.tempTimeEntryPrompt.Posted) {
          this.tempTimeEntryPrompt.error = 'Cannot edit / delete posted entry'
          return false
        }
      }
      if (this.noSOWDefined && this.tempTimeEntryPrompt.jiraIssueID != null) {
			  this.tempTimeEntryPrompt.error = "No SOW Defined for this task"
        return false
      }

      if (this.taskList.length == 0 && this.pendingTask != null) {
        this.tempTimeEntryPrompt.error = "Please wait for tasks to load."
        return false
      }
			this.tempTimeEntryPrompt.error = "Fields cannot be empty."

			if(this.tempTimeEntryPrompt.jiraIssueID == null && this.tempTimeEntryPrompt.taskID == null && this.tempTimeEntryPrompt.clientID == null){
        return false;
      }
			if(this.tempTimeEntryPrompt.categoryID == "" || this.tempTimeEntryPrompt.categoryID == null){
      	this.tempTimeEntryPrompt.error = "Missing category! Assign in All Projects."
				return false;
      }
			if(this.timeEntryStartTime == "" || this.timeEntryStartTime == null)
				return false;
			
      if(this.timeEntryStartDate == "" || this.timeEntryStartDate == null)
      return false;
      
			if(this.tempTimeEntryPrompt.description == "" || this.tempTimeEntryPrompt.description == null)
        return false;
        
      if(moment(this.timeEntryStartTime + " " + this.timeEntryStartDate , 'hh:mm A YYYY-MM-DD').isAfter(moment(this.timeEntryEndTime + " " + this.timeEntryEndDate , 'hh:mm A YYYY-MM-DD'))){
        this.tempTimeEntryPrompt.error = "Start time must be before end time."
        return false;
      }

      if(this.tempTimeEntryPrompt.action == "create" || this.tempTimeEntryPrompt.action == "clockin"){

      }else{

        if(this.timeEntryEndTime == "" || this.timeEntryEndTime == null)
          return false;
			  if(this.timeEntryEndDate == "" || this.timeEntryEndDate == null)
          return false;
      }
			
			return true;
		},
    timeEntryPrompt() {
        return this.$store.getters.GetTimeEntryPrompt
    },
    timeEntryPromptActive(){
      return this.$store.getters.GetTimeEntryPromptActive
    },
    timeEntryPromptTick(){
      return this.$store.getters.GetTimeEntryPromptTick
    },
    userLoggedIn(){
			return this.$auth.isAuthenticated
		},
    bodyOverlay () { return this.$store.state.bodyOverlay },
    contentAreaClass () {
      if (this.mainLayoutType === 'vertical') {
        if      (this.verticalNavMenuWidth === 'default') return 'content-area-reduced'
        else if (this.verticalNavMenuWidth === 'reduced') return 'content-area-lg'
        else return 'content-area-full'
      } else return 'content-area-full'
    },
    footerClasses () {
      return {
        'footer-hidden': this.footerType === 'hidden',
        'footer-sticky': this.footerType === 'sticky',
        'footer-static': this.footerType === 'static'
      }
    },
    isAppPage () {
      return this.$route.meta.no_scroll
    },
    isThemeDark ()     { return this.$store.state.theme === 'dark' },
    layoutTypeClass () { return `main-${this.mainLayoutType}`      },
    mainLayoutType ()  { return this.$store.state.mainLayoutType   },
    navbarClasses ()   {
      return {
        'navbar-hidden'   : this.navbarType === 'hidden',
        'navbar-sticky'   : this.navbarType === 'sticky',
        'navbar-static'   : this.navbarType === 'static',
        'navbar-floating' : this.navbarType === 'floating'
      }
    },
    verticalNavMenuWidth () { return this.$store.state.verticalNavMenuWidth },
    windowWidth ()          { return this.$store.state.windowWidth },
    isClient(){
      return this.$store.getters.GetIsClient
    },

  },
  methods: {
    BeginMarkComplete(task) {
      if (this.savingTimeEntry) return
      console.log('completing task', task)
      this.confirmingCompleteLineItem = true
    },
    async FinishMarkTaskComplete() {
      if (this.completingLineItem || this.savingTimeEntry) return
      this.completingLineItem = true
      try {
        await this.$store.dispatch('ActionMarkTaskComplete', {
          sowLineItemId: this.selectedSOWLineItem.SOWLineItemID
        })
        this.confirmingCompleteLineItem = false
        this.AcceptTimeEntryPrompt()
      } catch(e) {
        console.error(e)
        this.confirmingCompleteLineItem = false
      } finally {
        this.completingLineItem = false
      }
    },
    ViewTaskInJira() {
      window.open(
        `https://${this.$store.getters.GetJiraDomain}.atlassian.net/browse/${this.tempTimeEntryPrompt.jiraIssueKey}`,
        "_blank"
      )
    },
    // ChangeStatus(status){
    //   console.log("Changing issue status to ", status)
    //   var statusID = status.id
    //   var issueID = this.tempTimeEntryPrompt.task.JiraInfo.id
    //   console.log(issueID)
    //   console.log(statusID)
    //   this.$store.dispatch("ActionSetTaskStatus", {StatusID: statusID, IssueID: issueID, Task: this.tempTimeEntryPrompt.task.JiraInfo, Status: status}).then(x=>{
    //     this.selectingTemplate = 0
    //   })
    // },
    TimelineStyle(index, count){
      
      var l2 = index / parseFloat(count)
      var l1 = (1-l2)

      var fromR = 115
      var fromG = 103
      var fromB = 240

      // var fromR = 240
      // var fromG = 103
      // var fromB = 103

      var toR = 40
      var toG = 199
      var toB = 111

      var finalR = fromR * l1 + toR * l2
      var finalG = fromG * l1 + toG * l2
      var finalB = fromB * l1 + toB * l2

      var final = "rgb(" + finalR + "," + finalG + "," + finalB + ")"

      return { 
        "background-color": final
      }

    },
    SelectStatusChanger(){
      this.selectingTemplate = 2
    },
    RemoveEndTime(){
      this.timeEntryEndTime = null
      this.timeEntryEndDate = null
    },
    AddEndTime(){
      this.timeEntryEndTime = moment().format('hh:mm A')
      this.timeEntryEndDate = moment().format('Y-MM-DD')
    },
    GetCategoryByID(categoryID){
			var category = this.rawCategoryList.find(x => x.CategoryID == categoryID)
			if(category == null)
				category = {CategoryName : "None", CategoryID: "None"}

			return category
		},
    GetDateDay(s){
			return moment(s, "YYYY-MM-DD hh:mm A").format("M/DD")
		},
		GetDateTimes(s, e){
			var format = "YYYY-MM-DD hh:mm A"
			return moment(s, format).format("h:mm A") + " - " + moment(e, format).format("h:mm A") 
		},
		GetTimeDif(s, e){
			var format = "YYYY-MM-DD hh:mm A"

			var ms = moment(e,format).diff(moment(s,format));
			var d = moment.duration(ms);
			var p = Math.floor(d.asHours()) + moment.utc(ms).format(":mm");

			return p

		},
    GetClientByID(clientID){
			var client = this.clientList.find(x => x.ClientID === clientID)
			if(client == null)
				client = {ClientName:"None"}

			return client
		},
    BeginSelectTemplate(){
    
      this.selectingTemplate = 1
    },
    CancelSelectTemplate(){
        const ps = this.$refs.scroll
      ps.$el.scrollTop = 0
      ps.update()
      this.selectingTemplate = 0
    },
    OnLoggedIn(fromSimulation){
      this.doneLoading = true

      this.GetUserClient().catch(() => {})

      var promises = []

      this.$store.dispatch('ActionAutoSignIn', false)

      promises.push(this.GetWorkerList())

      if(this.isClient){
        promises.push(this.GetMonthlyTable())
        promises.push(this.GetMonthlyChart())
      } else {
        
      
        this.$store.dispatch('ActionFetchMyTaskList')
        this.$store.dispatch('ActionFetchMyTaskListV2')
        this.$store.dispatch('ActionFetchSOWs')
        this.$store.dispatch('ActionFetchMySOWLineItems')

        // this.GetTaskList()
        promises.push(this.GetEntries())
        promises.push(this.GetHoursWorked())
        promises.push(this.GetCategories())
        promises.push(this.GetWorkerMessages())
        promises.push(this.GetSOWStatusIDLookups())
        promises.push(this.GetSOWOverageStatusIDLookups())
        // promises.push(this.GetTaskList())
      }
      Promise.all(promises).catch(() => {})
    },
    GetSOWOverageStatusIDLookups(){
      return this.$store.dispatch("ActionFetchSOWOverageStatusIDLookups")
    },
    GetSOWStatusIDLookups(){
      return this.$store.dispatch("ActionFetchSOWStatusIDLookups")
    },
    GetTaskStatusIDLookups(){
      return this.$store.dispatch("ActionFetchTaskStatusIDLookups")
    },
    GetWorkerMessages(){
      return this.$store.dispatch("ActionFetchWorkerMessages")
    },
    GetMonthlyTable(){
      return this.$store.dispatch("ActionFetchMonthlyTable", null)
    },
    GetMonthlyChart(){
      return this.$store.dispatch("ActionFetchMonthlyChart", null)
    },
    GetWorkerList(){
      return this.$store.dispatch("ActionFetchWorkerList", null)
    },
    GetEntries (){
			return this.$store.dispatch("ActionFetchTimeEntries");
    },
    GetCategories(){
      return this.$store.dispatch("ActionFetchCategories", null)
    },
    NAN(input){
      if(input == null){
        return true
      }
      return isNaN(input)
    },
    ClientIsDisabled(){
      if(this.NAN(this.tempTimeEntryPrompt.jiraIssueID) && this.NAN(this.tempTimeEntryPrompt.clientID)){
        return false
      }
      if(!this.NAN(this.tempTimeEntryPrompt.jiraIssueID)){
        return true
      }
      return false
    },
    TaskIsDisabled(){
      if(this.NAN(this.tempTimeEntryPrompt.jiraIssueID) && this.NAN(this.tempTimeEntryPrompt.clientID)){
        return false
      }

      if(!this.NAN(this.tempTimeEntryPrompt.clientID)){
        return true
      }
      return false
    },
    onFromChange(selectedDates, dateStr, instance) {
      //this.$set(this.datePickerConfig, 'minDate', dateStr);
    },
    onToChange(selectedDates, dateStr, instance) {
     // this.$set(this.datePickerConfig, 'maxDate', dateStr);
    },
    OnChangedClient (clientID){
      this.tempTimeEntryPrompt.categoryID = null
      this.tempTimeEntryPrompt.projectID = null
      this.tempTimeEntryPrompt.jiraIssueID = null
      this.tempTimeEntryPrompt.taskID = null
      this.tempTimeEntryPrompt.sowID = null
      this.tempTimeEntryPrompt.sowLineItemID = null
    },
    OnChangedProject(x){
      this.tempTimeEntryPrompt.jiraIssueID = null
    },
    OnChangedCategory(x){
      this.tempTimeEntryPrompt.jiraIssueID = null
      this.tempTimeEntryPrompt.taskID = null
      this.tempTimeEntryPrompt.projectID = null
      this.tempTimeEntryPrompt.sowID = null
      this.tempTimeEntryPrompt.sowLineItemID = null
    },
    BeginCreateCategory() {
      this.creatingCategory = true
      this.$nextTick(() => {
        const ref = this.$refs.newCategoryInput
        const input = ref && ref.$el && ref.$el.querySelector('input')
        if (input) input.focus()
      })
    },
    CancelCreateCategory() {
      this.creatingCategory = false
      this.newCategory = ''
    },
    BeginCreateTask() {
      this.creatingTask = true
      this.$nextTick(() => {
        const ref = this.$refs.newTaskInput
        const input = ref && ref.$el && ref.$el.querySelector('input')
        if (input) input.focus()
      })
    },
    CancelCreateTask() {
      this.creatingTask = false
      this.newTaskDescription = ''
    },
    async CreateTask() {
      if (!this.newTaskDescription.trim()) return
      this.savingTask = true
      try {
        const created = await this.$store.dispatch('ActionCreateLineItem', {
          SOWID: this.tempTimeEntryPrompt.sowID,
          Title: this.newTaskDescription.trim(),
          TimeEstimate: 0,
          IsCompleted: false,
          AssignedTo: this.workerID,
        })
        await this.$store.dispatch('ActionFetchMySOWLineItems')
        const list = this.$store.getters.GetMySOWLineItems
        const match = list.find(x => x.SOWID === this.tempTimeEntryPrompt.sowID && x.Title === this.newTaskDescription.trim())
        const id = (created && created.SOWLineItemID != null) ? created.SOWLineItemID : (match ? match.SOWLineItemID : null)
        if (id != null) this.tempTimeEntryPrompt.sowLineItemID = id
        this.newTaskDescription = ''
      } catch (e) {
        console.error(e)
      }
      this.savingTask = false
      this.creatingTask = false
    },
    repositionTimeEntryFlatpickrs() {
      const refs = ['fpStartTime', 'fpStartDate', 'fpEndTime', 'fpEndDate']
      refs.forEach(key => {
        const comp = this.$refs[key]
        if (comp && comp.fp && typeof comp.fp._positionCalendar === 'function') {
          comp.fp._positionCalendar()
        }
      })
    },
    async CreateCategory() {
      this.savingCategory = true
      try {
        await this.$store.dispatch('ActionSaveCategory', { CategoryName: this.newCategory, ClientID: this.tempTimeEntryPrompt.clientID })
        await this.$store.dispatch('ActionFetchCategories')
        const created = this.$store.getters.GetCategoryList.find(x => x.CategoryName === this.newCategory && x.ClientID === this.tempTimeEntryPrompt.clientID)
        if (created) this.tempTimeEntryPrompt.categoryID = created.CategoryID
        this.newCategory = ''
      } catch (e) {
        console.error(e)
      }
      this.savingCategory = false
      this.creatingCategory = false
    },
    onChangedSOW() {
      this.tempTimeEntryPrompt.sowLineItemID = null
      if (this.tempTimeEntryPrompt.sowID != null) {

        let fullSOW = this.mySOWs.find(x => x.SOWID == this.tempTimeEntryPrompt.sowID)
        this.tempTimeEntryPrompt.categoryID = fullSOW.CategoryID
        this.tempTimeEntryPrompt.clientID = fullSOW.ClientID
      }
    },
    BeginCreateSOW () {
      if (this.$refs.sowModal) {
        this.$refs.sowModal.OpenForCreate()
      }
    },
    OnSOWCreatedFromTimeEntry (savedSOW) {
      if (!savedSOW || savedSOW.SOWID == null) return
      this.$store.dispatch('ActionFetchSOWs')
      this.$store.dispatch('ActionFetchMySOWLineItems')
      this.tempTimeEntryPrompt.sowID = savedSOW.SOWID
      if (savedSOW.ClientID != null) {
        this.tempTimeEntryPrompt.clientID = savedSOW.ClientID
      }
      if (savedSOW.CategoryID != null) {
        this.tempTimeEntryPrompt.categoryID = savedSOW.CategoryID
      }
    },
    onChangedSOWLineItem() {
      if (this.tempTimeEntryPrompt.sowID == null) {
        let fullSOW = this.mySOWLineItemsWithOrphans.find(x => x.SOWLineItemID == this.tempTimeEntryPrompt.sowLineItemID)
        if (fullSOW) {
          this.tempTimeEntryPrompt.sowID = fullSOW.SOWID
          this.tempTimeEntryPrompt.categoryID = fullSOW.CategoryID
          this.tempTimeEntryPrompt.clientID = fullSOW.ClientID
        }
      }
    },
    GetTaskByID(jiraIssueID){
      var x = this.taskList.find(x => x.id == jiraIssueID)
      if(x != null)
        return x
      return null
    },
    GetProjectByID(projectID){
      return this.projectList.find(x=>x.ITATInfo.ProjectID == projectID)
    },
    GetTaskIDByJiraID(jiraID){
      var x = this.taskList.find(x => x.id == jiraID)
      if(x != null)
        return x.JiraIssueID
      return null
    },
     GetProjectIDByJiraID(jiraID){
      var x = this.projectList.find(x => x.id == jiraID)
      if(x != null)
        return x.ProjectID

      return null
    },
    OnChangedTask (taskID){
      if(taskID == null) {
        this.tempTimeEntryPrompt.taskID = null
        this.tempTimeEntryPrompt.sowLineItemID = null
        this.tempTimeEntryPrompt.task = null
        this.tempTimeEntryPrompt.jiraIssueID = null
        return
      }

      var task = this.taskList.find(x => x.TaskID === taskID)
      if (task != null) {
        this.tempTimeEntryPrompt.taskID = task.TaskID
        this.tempTimeEntryPrompt.sowLineItemID = task.SOWLineItemID || null
        this.tempTimeEntryPrompt.clientID = task.ClientID
        this.tempTimeEntryPrompt.categoryID = task.CategoryID
        this.tempTimeEntryPrompt.task = task
        this.tempTimeEntryPrompt.jiraIssueID = null
        return
      }

      task = this.taskList.find(x => x.id == taskID)
      if(task == null) return

      this.tempTimeEntryPrompt.projectID = task.fields.project.id
      const projectCategoryId = task.fields.project.categoryId
      if (projectCategoryId != null) {
        const client = null
        if (client != null) {
          this.tempTimeEntryPrompt.clientID = client.ClientID
        }
      }
      this.tempTimeEntryPrompt.task = task
      var project = this.projectList.find(x => x.id == task.fields.project.id)
      if (project == null) return
      this.tempTimeEntryPrompt.categoryID = task.ITATCategoryID
      // if (potentialCategory != null) {
      //   console.log('Found potential category', potentialCategory)
      //   this.tempTimeEntryPrompt.categoryID = potentialCategory.CategoryID
      //   // this.$store.commit('SetCategoryListSOW', [potentialCategory])
      // } else {
        
      //   this.$store.dispatch('ActionGetCategoryFromSOW', {
      //     ClientID: task.ITATInfo.ClientID,
      //     EpicName: sow,
      //   }).then(x => {
      //     console.log('Got categories for sow: ', x)
      //     this.tempTimeEntryPrompt.categoryID = x[0].CategoryID
      //   })
      // }
      
      // var categoryID = project.ITATInfo.CategoryID   
      // console.log("Category: ")
      // console.log(categoryID)
      // this.tempTimeEntryPrompt.categoryID = categoryID
      
    },
    CancelTimeEntryPrompt(){
      this.$store.commit("SetPotentialExternalTask", null)
      this.$store.dispatch("ActionSetTimeEntryPrompt", {"active": false})
    },
    CloseTimeEntryPromptAfterSave () {
      this.$store.commit("SetPotentialTaskToMine")
      this.$store.dispatch("ActionSetTimeEntryPrompt", {"active": false})
      this.selectingTemplate = 0
    },
    HandleTimeEntrySaveError (error) {
      const message = error && error.response && error.response.data && error.response.data.message
        ? error.response.data.message
        : 'Unable to save time entry. Please review and try again.'
      this.$vs.notify({
        color: 'danger',
        title: 'Save failed',
        text: message
      })
    },
    AcceptTimeEntryPrompt(){
      if (this.savingTimeEntry) return
      this.savingTimeEntry = true
      if (this.tempTimeEntryPrompt.action == "create") { //CREATE ENTRIE

       
        var timeIn = this.timeEntryStartDate + " " + this.GetFormattedTime(this.timeEntryStartTime)
        var timeOut = this.timeEntryEndTime == null ? null :  moment((this.timeEntryEndDate + " " + this.GetFormattedTime(this.timeEntryEndTime)), "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()

        var timeInUTC = moment(timeIn, "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()
        
        //return
        this.$store.dispatch("ActionPostTimeEntry", 
          {
            "TimeIn"				  : timeInUTC,
            "TimeOut"				  : timeOut,
            "ClientID"				: this.tempTimeEntryPrompt.clientID,
            "CategoryID"			: this.tempTimeEntryPrompt.categoryID,
            "JiraIssueID"      : this.tempTimeEntryPrompt.jiraIssueID,
            "TaskID"          : this.tempTimeEntryPrompt.taskID,
            "ProjectID"       : this.tempTimeEntryPrompt.projectID,
            "Note"					  : this.tempTimeEntryPrompt.description,
            "Mileage"					: this.tempTimeEntryPrompt.mileage,
            "SOWID"					  : this.tempTimeEntryPrompt.sowID,
            "SOWLineItemID"		: this.tempTimeEntryPrompt.sowLineItemID,
          }
        ).then(response=>{
          this.CloseTimeEntryPromptAfterSave()
           this.$vs.notify({
					color: 'success',
					title:"Created Entry!"
				})
          this.GetHoursWorked()
        }).catch(error => {
          this.HandleTimeEntrySaveError(error)
        }).finally(() => {
          this.savingTimeEntry = false
        })
      } else if (this.tempTimeEntryPrompt.action == "clockout") { //CLOCK OUT
        var timeIn = this.timeEntryStartDate + " " + this.GetFormattedTime(this.timeEntryStartTime)
        var timeOut = this.timeEntryEndTime == null ? null :  (this.timeEntryEndDate + " " + this.GetFormattedTime(this.timeEntryEndTime))

        var timeInUTC = moment(timeIn, "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()
        var timeOutUTC = moment(timeOut, "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()
        this.$store.dispatch("ActionPutTimeEntry", 
          {
            "RecordID"        : this.tempTimeEntryPrompt.recordID,
            "TimeIn"				  : timeInUTC,
            "TimeOut"				  : timeOutUTC,
            "ClientID"				: this.tempTimeEntryPrompt.clientID,
            "CategoryID"			: this.tempTimeEntryPrompt.categoryID,
            "JiraIssueID"     : this.tempTimeEntryPrompt.jiraIssueID,
            "TaskID"          : this.tempTimeEntryPrompt.taskID,
            "ProjectID"       : this.tempTimeEntryPrompt.projectID,
            "Note"					  : this.tempTimeEntryPrompt.description,
            "Mileage"					: this.tempTimeEntryPrompt.mileage,
            "SOWID"					  : this.tempTimeEntryPrompt.sowID,
            "SOWLineItemID"		: this.tempTimeEntryPrompt.sowLineItemID,
            "ClockingOut"     : true
          }).then(response => {
            this.CloseTimeEntryPromptAfterSave()
            this.$store.commit("SetCurrentTimeEntry", null)
            this.$store.dispatch("ActionSetNewTimeEntry",response.data)
            this.GetHoursWorked()
             this.$vs.notify({
              color: 'success',
              title:"Clocked Out!"
            })
          }).catch(error => {
            this.HandleTimeEntrySaveError(error)
          }).finally(() => {
            this.savingTimeEntry = false
          })

      }
      else if(this.tempTimeEntryPrompt.action == "edit"){ //EDIT
        
        var timeIn = this.timeEntryStartDate + " " + this.GetFormattedTime(this.timeEntryStartTime)
        var timeOut = this.timeEntryEndTime == null ? null :  (this.timeEntryEndDate + " " + this.GetFormattedTime(this.timeEntryEndTime))

        var timeInUTC = moment(timeIn, "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()
        var timeOutUTC = moment(timeOut, "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()
        this.$store.dispatch("ActionPutTimeEntry", 
          {
            "RecordID"        : this.tempTimeEntryPrompt.recordID,
            "TimeIn"				  : timeInUTC,
            "TimeOut"				  : timeOutUTC,
            "ClientID"				: this.tempTimeEntryPrompt.clientID,
            "CategoryID"			: this.tempTimeEntryPrompt.categoryID,
            "JiraIssueID"      : this.tempTimeEntryPrompt.jiraIssueID,
            "TaskID"          : this.tempTimeEntryPrompt.taskID,
            "ProjectID"       : this.tempTimeEntryPrompt.projectID,
            "Note"					  : this.tempTimeEntryPrompt.description,
            "Mileage"					  : this.tempTimeEntryPrompt.mileage,
            "SOWID"					  : this.tempTimeEntryPrompt.sowID,
            "SOWLineItemID"		: this.tempTimeEntryPrompt.sowLineItemID,
            "ClockingOut"     : false,
            "JiraLogID"       : this.tempTimeEntryPrompt.jiraLogID
          }).then(response => {
             this.CloseTimeEntryPromptAfterSave()
             this.$vs.notify({
              color: 'success',
              title:"Edited Entry!"
            })
            //this.$store.dispatch("ActionSetNewTimeEntry",response.data)
            this.GetHoursWorked()
          }).catch(error => {
            this.HandleTimeEntrySaveError(error)
          }).finally(() => {
            this.savingTimeEntry = false
          })
       // this.$store.commit("SetCurrentTimeEntry", null)

      }else if(this.tempTimeEntryPrompt.action == "clockin"){ //CLOCK IN
        var timeIn = this.timeEntryStartDate + " " + this.GetFormattedTime(this.timeEntryStartTime)
        var timeInUTC = moment(timeIn, "YYYY-MM-DD hh:mm A").utc().add(1, "hours").format()

        this.$store.dispatch("ActionPostTimeEntry", 
          {
            "WorkerName"			: "Miles Every",
            "TimeIn"				  : timeInUTC,
            "ClientID"				: this.tempTimeEntryPrompt.clientID,
            "CategoryID"			: this.tempTimeEntryPrompt.categoryID,
            "ProjectID"       : this.tempTimeEntryPrompt.projectID,
            "Note"					  : this.tempTimeEntryPrompt.description,
            "Mileage"					: this.tempTimeEntryPrompt.mileage,
            "SOWID"					  : this.tempTimeEntryPrompt.sowID,
            "SOWLineItemID"		: this.tempTimeEntryPrompt.sowLineItemID,
            "TaskID"          : this.tempTimeEntryPrompt.taskID,
          }
        ).then(response => {
            this.CloseTimeEntryPromptAfterSave()
             this.$vs.notify({
              color: 'success',
              title:"Clocked In!"
            })
            this.GetHoursWorked()
            this.$router.push("/timeEntries")

          }).catch(error => {
            this.HandleTimeEntrySaveError(error)
          }).finally(() => {
            this.savingTimeEntry = false
          })
      } else {
        this.savingTimeEntry = false
      }
      

    },
    SelectTemplate(entry){

      this.tempTimeEntryPrompt.jiraIssueID = entry.JiraIssueID

      this.tempTimeEntryPrompt.clientID = entry.ClientID
      this.tempTimeEntryPrompt.projectID = entry.ProjectID
      this.tempTimeEntryPrompt.categoryID = entry.CategoryID

      if(entry.JiraIssueID != null){
        var task = this.GetTaskByID(entry.JiraIssueID)
        if (task != null) {
          this.tempTimeEntryPrompt.task = task
          this.tempTimeEntryPrompt.jiraIssueID = task.id
          const client = null
          if (client != null) {
            this.tempTimeEntryPrompt.clientID = client.ClientID
          }
          // this.tempTimeEntryPrompt.clientID = task.ITATInfo.ClientID
          this.tempTimeEntryPrompt.projectID = task.fields.project.id
          //this.tempTimeEntryPrompt.categoryID = this.GetProjectByID(this.tempTimeEntryPrompt.projectID).ITATInfo.CategoryID
         
         } else {
           this.tempTimeEntryPrompt.jiraIssueID = null
         }
      }


      this.tempTimeEntryPrompt.description = entry.Note
      this.tempTimeEntryPrompt.mileage = entry.Mileage

      // this.tempTimeEntryPrompt.recordID = entry.RecordID
      // this.tempTimeEntryPrompt.startTime = moment(entry.TimeIn, "YYYY-MM-DD hh:mm A").format('hh:mm A')
      // this.tempTimeEntryPrompt.startDate = moment(entry.TimeIn, "YYYY-MM-DD hh:mm A").format('Y-MM-DD')
      // this.tempTimeEntryPrompt.endTime = moment(entry.TimeOut, "YYYY-MM-DD hh:mm A").format('hh:mm A')
      // this.tempTimeEntryPrompt.endDate = moment(entry.TimeOut, "YYYY-MM-DD hh:mm A").format('Y-MM-DD')

      this.CancelSelectTemplate()
    },
    ConfirmDeleteEntry(){
      this.deletingEntry = false
			this.$vs.notify({
				color:"danger",
				title:"Deleted Entry"
			})
			this.$store.dispatch("ActionDeleteTimeEntry", 
			{
			  RecordID: this.tempTimeEntryPrompt.recordID,
        JiraIssueID: this.tempTimeEntryPrompt.jiraIssueID
			}).then(response=>{
        this.$store.dispatch("ActionSetTimeEntryPrompt", {"active": false})
        this.GetHoursWorked()
      })

    },
    UpdateStartTime(){
      var currentTime = moment().format('hh:mm A')
      var currentDate = moment().format('Y-MM-DD')
      this.timeEntryStartTime = currentTime
      this.timeEntryStartDate = currentDate
    },
    UseMostRecentEndForStartTime () {
      if (this.mostRecentCompletedEntry == null || this.mostRecentCompletedEntry.TimeOut == null) return
      const m = moment(this.mostRecentCompletedEntry.TimeOut)
      if (!m.isValid()) return
      this.timeEntryStartTime = m.format('hh:mm A')
      this.timeEntryStartDate = m.format('Y-MM-DD')
    },
    UpdateEndTime(){
      var currentTime = moment().format('hh:mm A')
      var currentDate = moment().format('Y-MM-DD')
      this.timeEntryEndTime = currentTime
      this.timeEntryEndDate = currentDate
    },
    GetFormattedTime(time){
      if(time == null)
        return ""
      if(time.length == 7){
        return "0" + time;
      }else{
        return time
      }
    },
    GetUserClient(){
      return this.$store.dispatch("ActionFetchUserClient")
    },
    GetHoursWorked(){
      this.$store.dispatch("ActionFetchHoursWorkedDaily", moment().format("YYYY-MM-DD")) //Get daily
      this.$store.dispatch("ActionFetchHoursWorkedWeekly", moment().format("YYYY-MM-DD")) //Get daily
      this.$store.dispatch("ActionFetchBillableHoursWorkedWeekly", moment().format("YYYY-MM-DD")) //Get daily

    },
    changeRouteTitle (title) {
      this.routeTitle = title
    },
    updateNavbarColor (val) {
      this.navbarColor = val
      if (val === '#fff') this.isNavbarDark = false
      else this.isNavbarDark = true
    },
    setNavMenuVisibility (layoutType) {
      if ((layoutType === 'horizontal' && this.windowWidth >= 1200) || (layoutType === 'vertical' && this.windowWidth < 1200)) {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', false)
        this.$store.dispatch('updateVerticalNavMenuWidth', 'no-nav-menu')
      } else {
        this.$store.commit('TOGGLE_IS_VERTICAL_NAV_MENU_ACTIVE', true)
      }
    }
  },
  created () {
    const color = this.navbarColor === '#fff' && this.isThemeDark ? '#10163a' : this.navbarColor
    this.updateNavbarColor(color)
    this.setNavMenuVisibility(this.$store.state.mainLayoutType)
    
   // this.interval = setInterval(() => this.GetHoursWorked(), 1000);
    
  },
  mounted(){
    document.title = 'ITAT Time'
    if (!this.$auth.loading && !this.$auth.isAuthenticated) {
      this.$router.replace('/')
      return
    }
    if(this.userLoggedIn){
		  this.OnLoggedIn()
		}
  }
}

</script>

<style lang="css">
.time-entry-prompt .vs-dialog {
  max-width: 90% !important;
  max-height: 85vh !important;
  display: flex !important;
  flex-direction: column !important;
}
.time-entry-prompt .vs-dialog header,
.time-entry-prompt .vs-dialog footer {
  flex-shrink: 0;
}
.time-entry-prompt .vs-dialog .vs-dialog-text {
  flex: 0 1 auto;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 1rem;
}
.time-entry-modal-layout {
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.time-entry-modal-body {
  flex: 0 1 auto;
  min-height: 0;
  overflow-y: auto;
  overscroll-behavior: contain;
}
.time-entry-modal-footer {
  flex-shrink: 0;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 1rem 0 0;
  margin-top: 1rem;
}
.time-entry-prompt-footer-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}
.time-entry-prompt-footer-left {
  display: flex;
  align-items: center;
}
.time-entry-prompt-footer-right {
  display: flex;
  align-items: center;
}
.time-entry-prompt-footer-right .vs-button:not(:first-child) {
  margin-left: 0.5rem;
}
.taskStatusButton{
  margin-top: 0px;
  position: absolute;
  top: 4px;
  right: 2px;
}
.taskStatusButton.second {
  top: 33px;
  width: 114px;
}
.statusButton{
  width: 100% !important;
}
.sow-notification {
  position: absolute;
    padding: 5px;
    background: #ea5455;
    margin-left: 563px;
    border-radius: 5px;
}
.sow-notification .text {
  white-space: nowrap;
}
.time-entry-task-row {
  min-width: 0;
}
.time-entry-task-select {
  min-width: 0;
}
.time-entry-task-select .vs__selected-options {
  flex-wrap: nowrap;
  overflow: hidden;
}
.time-entry-task-select .vs__selected {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.time-entry-task-select .vs__search {
  min-width: 1px;
}
.time-entry-task-add-btn {
  flex-shrink: 0;
}
.time-entry-ellipsis-select {
  min-width: 0;
}
.time-entry-ellipsis-select .vs__dropdown-toggle {
  overflow: hidden;
}
.time-entry-ellipsis-select .vs__selected-options {
  flex-wrap: nowrap;
  overflow: hidden;
}
.time-entry-ellipsis-select .vs__selected {
  max-width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  display: block;
}
.time-entry-ellipsis-select .vs__search {
  min-width: 1px;
}
.square {
  position: absolute;
  background: #ea5455;
  width: 6px;
  height: 6px;
  left: -3px;
  top: 12px;
  transform: rotate(45deg);
}
.timeEntryUseLastEndBtn {
  position: absolute;
  top: -14px;
  right: 0px;
}

.vs-dialog .vs-dialog-text {
  overflow: auto;
  max-height: calc(100vh - 150px);
}

.con-vs-dialog .vs-dialog {
  max-width: 600px !important;
}

.v-select {
  margin-top: 10px;
}
.v-select > div {
  height: 38px;
}

</style>

<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>